import {
  parentConnectionSchema,
  trustedConnectionSchema,
  type ConnectionListQuery,
  type Page,
  type ParentConnection,
  type ParentConnectionDecisionInput,
  type RequestParentConnectionInput,
  type SetTrustedConnectionInput,
  type TrustedConnection,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** Employers this guardian has vouched for — or blocked. */
export function fetchTrustedConnections(
  query: Partial<ConnectionListQuery> = {},
): Promise<Page<TrustedConnection>> {
  return fetchPage('/connections/trusted', trustedConnectionSchema, query);
}

export async function setTrustedConnection(
  input: SetTrustedConnectionInput,
): Promise<TrustedConnection> {
  const result = await apiFetch<unknown>('/connections/trusted', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
  return trustedConnectionSchema.parse(result);
}

export async function removeTrustedConnection(jobPosterId: string): Promise<void> {
  await apiFetch<void>(`/connections/trusted/${jobPosterId}`, { method: 'DELETE' });
}

/** Other guardians this parent is connected to. */
export function fetchParentConnections(
  query: Partial<ConnectionListQuery> = {},
): Promise<Page<ParentConnection>> {
  return fetchPage('/connections/parents', parentConnectionSchema, query);
}

export async function requestParentConnection(
  input: RequestParentConnectionInput,
): Promise<ParentConnection> {
  return parentConnectionSchema.parse(await post<unknown>('/connections/parents', input));
}

export async function decideParentConnection(
  connectionId: string,
  input: ParentConnectionDecisionInput,
): Promise<ParentConnection> {
  return parentConnectionSchema.parse(
    await post<unknown>(`/connections/parents/${connectionId}/decision`, input),
  );
}
